import PropTypes from 'prop-types';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  DataContainerStyled,
  OrderContentContainerStyled,
  OrderSectionStyled,
  OrderTitleContainerStyled,
  SectionElementStyled,
  TitleStyled,
  ValueStyled,
} from './TrlNewOrderDataContainer.styles';

export const TrlNewOrderDataContainer = memo(({ data, activeStep }) => (
  <DataContainerStyled activeStep={activeStep}>
    {data.map((section, index) => (
      <OrderSectionStyled
        key={index + section.label}
        id={index + section.label}
        index={index}
      >
        <OrderTitleContainerStyled>
          <TitleStyled>
            <FormattedMessage id={section.label} />
          </TitleStyled>
        </OrderTitleContainerStyled>
        <OrderContentContainerStyled>
          {section.elements.map((element) => (
            <SectionElementStyled
              key={index + element.value}
              id={index + element.value}
            >
              <FormattedMessage id={element.label} />:
              <ValueStyled>
                {!element.value || element.value === 0 ? '-' : element.value}
              </ValueStyled>
            </SectionElementStyled>
          ))}
        </OrderContentContainerStyled>
      </OrderSectionStyled>
    ))}
  </DataContainerStyled>
));

TrlNewOrderDataContainer.displayName = 'TrlNewOrderDataContainer';

TrlNewOrderDataContainer.propTypes = {
  data: PropTypes.array.isRequired,
  activeStep: PropTypes.number,
};
